import React from 'react';
import Image, { IImageProps } from 'tbk-components/src/components/Image';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';
import CPTShareBanner, { ICPTShareBannerProps } from '../CPTShareBanner';
import Spacer from '../Spacer';

export interface IWebinarHeroProps extends IBaseElementProps {
	postType?: string;
	postTitle?: string;
	date?: string;
	time?: string;
	ctaButtonLabel?: string;
	ctaButtonTarget?: string;
	featuredImage?: IImageProps;
	excerpt?: string;
	description?: string;
	cptShareBannerProps?: ICPTShareBannerProps;
}

const WebinarHero: React.FC<IWebinarHeroProps> = ({
	id,
	className,
	classNames = [],
	postType,
	postTitle,
	date,
	time,
	ctaButtonLabel,
	ctaButtonTarget,
	featuredImage,
	excerpt,
	description,
	cptShareBannerProps,
}) => {
	return (
		<div
			id={id}
			className={
				className || cn('webinar-hero__container', ...classNames)
			}
		>
			<div className="webinar-hero__container-inner">
				{postType && <span>{postType}</span>}
				<div className="webinar-hero__header">
					{postTitle && <h1>{postTitle}</h1>}
					{date && time && (
						<div className="webinar-hero__date-time">
							{date && <span>{date}</span>}
							{time && <span>{time}</span>}
						</div>
					)}
					{ctaButtonLabel && ctaButtonTarget && (
						<a
							href={ctaButtonTarget}
							target="_self"
							className="btn btn-primary btn-sm mt-3 d-lg-none"
						>
							{ctaButtonLabel}
						</a>
					)}
					{featuredImage && (
						<div className="webinar-hero__featured-image">
							<Image {...featuredImage} />
						</div>
					)}
				</div>
				{cptShareBannerProps && (
					<>
						<CPTShareBanner classNames={["mt-3"]} {...cptShareBannerProps} />
						<Spacer size="Extra Small on Mobile" />
					</>
				)}
				{excerpt && <p>{excerpt}</p>}
				{description && (
					<div
						dangerouslySetInnerHTML={{ __html: description }}
						className="webinar-hero__description"
					/>
				)}
			</div>
		</div>
	);
};

export default WebinarHero;
